var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGetPaid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 167,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 80.5,
    r: 80,
    fill: "#FFD6AE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 12.5,
    r: 8,
    fill: "#FFE6D5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 142.5,
    r: 6,
    fill: "#FFE6D5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 138.5,
    r: 10,
    fill: "#FFE6D5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 46.5,
    r: 10,
    fill: "#FFE6D5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 11.5,
    r: 7,
    fill: "#FFE6D5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 22.5,
    width: 166,
    height: 104,
    rx: 7.26,
    fill: "#EEF2F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.07,
    y: 46.69,
    width: 29.02,
    height: 21.77,
    rx: 2.42,
    fill: "#FFC299"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.84,
    cy: 53.94,
    r: 12.09,
    fill: "#FFAF79"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.32,
    cy: 53.94,
    r: 12.09,
    fill: "#FFC299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.07 110.78a2.42 2.42 0 0 1 2.42-2.42h24.18a2.42 2.42 0 0 1 0 4.84H43.5a2.42 2.42 0 0 1-2.42-2.42ZM77.35 110.78a2.42 2.42 0 0 1 2.42-2.42h24.18a2.42 2.42 0 1 1 0 4.84H79.77a2.42 2.42 0 0 1-2.42-2.42ZM113.63 110.78a2.42 2.42 0 0 1 2.42-2.42h24.18a2.42 2.42 0 1 1 0 4.84h-24.18a2.42 2.42 0 0 1-2.42-2.42ZM149.9 110.78a2.42 2.42 0 0 1 2.43-2.42h24.18a2.42 2.42 0 1 1 0 4.84h-24.18a2.42 2.42 0 0 1-2.42-2.42Z",
    fill: "#FFC299"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 92.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FF692E",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.78 116.24a4.08 4.08 0 1 1 1.1-5.49M103 129.95h3.05c.4 0 .79.04 1.17.14l3.22.78c.7.17 1.42.18 2.13.05l3.56-.7a4.9 4.9 0 0 0 2.48-1.29l2.52-2.44c.72-.7.72-1.84 0-2.54a1.88 1.88 0 0 0-2.4-.16l-2.94 2.14c-.42.3-.93.47-1.46.47h-2.83 1.8c1.02 0 1.84-.8 1.84-1.79v-.36a1.8 1.8 0 0 0-1.4-1.73l-2.77-.68a5.85 5.85 0 0 0-1.39-.16c-1.12 0-3.16.93-3.16.93l-3.42 1.43m16.33-9.95a4.08 4.08 0 1 1-8.16 0 4.08 4.08 0 0 1 8.16 0Zm-21 9.45v6.77c0 .65 0 .98.13 1.23.11.22.3.4.51.51.25.13.58.13 1.23.13h.93c.66 0 .98 0 1.23-.13.22-.11.4-.3.51-.51.13-.25.13-.58.13-1.23v-6.77c0-.65 0-.98-.13-1.23-.1-.22-.29-.4-.5-.5-.26-.13-.58-.13-1.24-.13h-.93c-.65 0-.98 0-1.23.12-.22.12-.4.3-.51.51-.13.25-.13.58-.13 1.23Z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 7,
    y: 22.5,
    width: 206,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    in: "SourceAlpha",
    result: "effect1_dropShadow_690_136444"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_690_136444"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    in: "SourceAlpha",
    result: "effect2_dropShadow_690_136444"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_690_136444",
    result: "effect2_dropShadow_690_136444"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_690_136444",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 74,
    y: 84.5,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_690_136444"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_690_136444",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetPaid);
export default __webpack_public_path__ + "static/media/get-paid.ff95d1db978a90d0e1d430ba86ba163d.svg";
export { ForwardRef as ReactComponent };